import React from 'react';
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useStartSignIn } from '#hooks/auth';
import { t } from '#i18n';

import { ReactComponent as CircularLogo } from '#assets/logo/circular.svg';

export const SocialSignIn = (props) => {
  const params = useParams();
  const platform = props?.platform || params?.platform;
  const startSignIn = useStartSignIn();

  const renderSignInButton = () => {
    switch (platform.toLowerCase()) {
      case 'github':
        return (
          <Button
            variant="solid"
            color="white"
            size="lg"
            width="100%"
            backgroundColor="gray.900"
            _hover={{ backgroundColor: 'gray.700' }}
            leftIcon={<GitHubLogo />}
            onClick={startSignIn.trigger}
            disabled={startSignIn.loading}
          >
            {t('signIn.platformSignIn', { platform: t('common.github') })}
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <Flex
      direction="column"
      minHeight="100vh"
      maxWidth="100vw"
      alignItems="center"
      justifyContent="center"
      backgroundColor="primary.500"
    >
      <Box
        padding="1px"
        rounded="lg"
        bgGradient="linear(to-r, yellow.300, #b400ff)"
      >
        <Box
          backgroundColor="primary.400"
          paddingX={12}
          paddingY={12}
          rounded="lg"
          boxShadow="lg"
          textAlign="center"
          maxWidth="360px"
        >
          <Icon
            as={CircularLogo}
            boxSize={20}
            marginX="auto"
            marginBottom={6}
          />
          <Text color="gray.100" fontSize="2xl" fontWeight="bold" mb={2}>
            {t('signIn.welcomeMessage')}
          </Text>
          <Text color="gray.100" fontSize="md" mb={6}>
            {t('signIn.appDescription')}
          </Text>
          {renderSignInButton()}
        </Box>
      </Box>
    </Flex>
  );
};

/* eslint-disable max-len */
const GitHubLogo = () => (
  <svg height="20" viewBox="0 0 16 16" width="20" fill="white">
    <path
      fillRule="evenodd"
      d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38
        0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01
        1.08.58 1.23.82.72 1.21 1.87.87
        2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12
        0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08
        2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0
        .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"
    />
  </svg>
);
/* eslint-enable max-len */
